import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setRefresh, setSelectedActivity } from "../../store/MahutiReducer";
import { mySteps } from "../../utils/stepperUtils";
import MahutiActivitiesItem from "./MahutiActivitiesItem";
import './MahutiActivitiesList.css'
export default function MahutiActivitiesList(props) {

    const selector = useSelector(state => state.reducer);
    const dispatch = useDispatch()
    const isSelected = (selector, item) => selector.selectedActivity && selector.selectedActivity.productId && selector.selectedActivity.productId === item.productId ? true : false;

    useEffect(() => {
        dispatch(setRefresh(false))
    }, [])

    return  <div className="MahutiActivitiesList ps-lg-5 pe-lg-4 p-3 pt-lg-4 pb-lg-0">
        <div className="tickets_con">
            {(props.tickets && props.tickets.length > 0) ? <>
                <h2 className="almoni_tzar_normal text-start mt-2 ms-1">בחרו פעילות אחת שמעניינת אתכם</h2>
                <div className="p-0 py-2">
                    {props.tickets?.map((item, index) => <div key={'cardItem.' + index} className="col-12 "><MahutiActivitiesItem {...item} lineId={'cardItem.' + index} lastItem={props.tickets.length -1 === index} currentStep={selector.currentStep} description={item.shortDescription__c} isSelected={isSelected(selector, item)}/> </div>)} 
                </div></>
            :
            <div>אין פעילויות</div>}
        </div>
    </div>


    // <ul className="list-group">

    //     {props.tickets.map((item,index) => <li key={'cardItem.' + index} className="list-group-item p-0 mt-1 border-0"><MahutiActivitiesItem {...item} isSelected={isSelected(selector, item)}/></li>)}
    // </ul>

}